var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"category-icon py-3"},[_c('a',{staticClass:"no-decoration",attrs:{"href":'/cerca/'+_vm.slug}},[_c('div',{staticClass:"d-flex flex-column justify-content-center"},[_c('img',{staticClass:"image",attrs:{"src":_vm.getIconForCategory()}}),_c('div',{staticClass:"bold cat-title text-center mt-1"},[_vm._v(_vm._s(_vm.name))])])])])
}
var staticRenderFns = []

export { render, staticRenderFns }